import {
    FETCH_ALL_COMPANIES,
    FETCH_APPLICATIONS,
    FETCH_COMPANY_METRICS
} from '../actions/actionTypes';

const initialState = {
    allCompanies:     [],
    allCompaniesMeta: {},
    applications:     [],
    companyMetrics:   {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_ALL_COMPANIES:
            return {
                ...state,
                allCompanies:     [...action.payload.companies],
                allCompaniesMeta: {...action.payload.meta}
            };
        case FETCH_APPLICATIONS:
            return {
                ...state,
                applications: [...action.payload]
            };
        case FETCH_COMPANY_METRICS:
            return {
                ...state,
                companyMetrics: { ...action.payload }
            };
        default:
            return state;
    }
};
